import { JSX, useMemo, useState } from 'react'
import { State } from 'src/components/registerBusiness/standardRegister'
import Account from 'src/components/registerBusiness/standardRegister/AccountStep'
import Confirmation from 'src/components/createPassword/confirmation'
import EmailStep from 'src/components/registerBusiness/standardRegister/EmailStep'
import EmailVerificationStep from 'src/components/registerBusiness/standardRegister/EmailVerificationStep'
import Form from './Form'
import { ActivationEmailStatus } from 'src/graphql/generated/graphql-types'

export type StandardRegisterProps = {
  firstName: string
  lastName: string
  email: string
  password: string
  isAuthenticated: boolean
  preRegistrationToken: string | null
  returnUrl: string | null
  cartId: number | null
  acceptAccountTerms: boolean
  offersByEmail: boolean
}

const StandardRegister = (props: StandardRegisterProps) => {
  const [state, setState] = useState<State>(!props.isAuthenticated ? State.email : State.account)

  const handleStateChange = (state: State) => {
    setState(state)
  }

  const content: JSX.Element = useMemo(() => {
    switch (state) {
      case State.email:
        return <EmailStep onNavigateNext={(emailActivationStatus) => {
          if (emailActivationStatus === ActivationEmailStatus.OngoingActivation) {
            handleStateChange(State.ongoingActivation)
          } else {
            handleStateChange(State.account)
          }
        }
        } />
      case State.account:
        return <Account isConsumer onNavigateBack={() => handleStateChange(State.email)} />
      case State.emailVerification:
        return <EmailVerificationStep />
      case State.ongoingActivation:
        return <EmailVerificationStep emailActivationStatus={ActivationEmailStatus.OngoingActivation} />
      case State.confirmation:
        return <Confirmation />
      default:
        return <></>
    }
  }, [state])

  return (
    <Form onStateChange={handleStateChange} state={state} defaultValues={props} {...props}>
      {content}
    </Form>
  )
}

export default StandardRegister
